import React from 'react';
import { Sparkles, Flower2, Heart, Wind } from 'lucide-react';

export const FloatingBeautyElements = () => {
  return (
    <>
      {/* Brush 1 - Top Left */}
      <div
        className="absolute top-10 left-5 pointer-events-none opacity-40"
        style={{
          animation: 'floatBrush1 8s ease-in-out infinite',
          transform: 'rotate(-15deg)',
        }}
      >
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="8" y="2" width="24" height="8" rx="2" fill="#D4AF37" opacity="0.6"/>
          <circle cx="20" cy="22" r="12" fill="#D4AF37" opacity="0.5"/>
          <circle cx="18" cy="20" r="10" fill="#D4AF37" opacity="0.4"/>
          <circle cx="22" cy="24" r="8" fill="#D4AF37" opacity="0.3"/>
        </svg>
      </div>

      {/* Flower - Top Right */}
      <div
        className="absolute top-20 right-10 pointer-events-none opacity-35"
        style={{
          animation: 'floatFlower 10s ease-in-out infinite',
          transform: 'rotate(25deg)',
        }}
      >
        <Flower2 size={48} color="#D4AF37" strokeWidth={1.5} />
      </div>

      {/* Diamond - Middle Left */}
      <div
        className="absolute top-1/3 left-8 pointer-events-none opacity-30"
        style={{
          animation: 'floatDiamond 12s ease-in-out infinite',
          transform: 'rotate(45deg)',
        }}
      >
        <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
          <polygon points="17.5,2 30,17.5 17.5,33 5,17.5" fill="none" stroke="#D4AF37" strokeWidth="1.5" opacity="0.6"/>
          <polygon points="17.5,8 25,17.5 17.5,27 10,17.5" fill="#D4AF37" opacity="0.3"/>
        </svg>
      </div>

      {/* Sparkles - Bottom Right */}
      <div
        className="absolute bottom-32 right-5 pointer-events-none opacity-35"
        style={{
          animation: 'floatSparkle 7s ease-in-out infinite',
        }}
      >
        <Sparkles size={44} color="#D4AF37" strokeWidth={1} />
      </div>

      {/* Heart - Middle Right */}
      <div
        className="absolute top-2/3 right-12 pointer-events-none opacity-25"
        style={{
          animation: 'floatHeart 11s ease-in-out infinite',
        }}
      >
        <Heart size={40} color="#D4AF37" strokeWidth={1.5} fill="#D4AF37" opacity="0.4" />
      </div>

      {/* Brush 2 - Bottom Left */}
      <div
        className="absolute bottom-20 left-12 pointer-events-none opacity-30"
        style={{
          animation: 'floatBrush2 9s ease-in-out infinite',
          transform: 'rotate(60deg)',
        }}
      >
        <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="7" y="1" width="24" height="7" rx="2" fill="#D4AF37" opacity="0.5"/>
          <ellipse cx="19" cy="20" rx="11" ry="13" fill="#D4AF37" opacity="0.4"/>
          <ellipse cx="19" cy="18" rx="9" ry="11" fill="#D4AF37" opacity="0.3"/>
        </svg>
      </div>

      {/* Lipstick - Top Center Right */}
      <div
        className="absolute top-1/4 right-1/3 pointer-events-none opacity-25"
        style={{
          animation: 'floatLipstick 13s ease-in-out infinite',
          transform: 'rotate(-30deg)',
        }}
      >
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="10" y="2" width="12" height="20" rx="2" fill="#D4AF37" opacity="0.5"/>
          <circle cx="16" cy="26" r="4" fill="#D4AF37" opacity="0.4"/>
        </svg>
      </div>

      {/* Perfume Bottle - Bottom Center */}
      <div
        className="absolute bottom-1/4 left-1/3 pointer-events-none opacity-28"
        style={{
          animation: 'floatPerfume 15s ease-in-out infinite',
          transform: 'rotate(15deg)',
        }}
      >
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="12" y="2" width="12" height="6" fill="#D4AF37" opacity="0.5"/>
          <rect x="10" y="8" width="16" height="20" rx="2" fill="#D4AF37" opacity="0.4"/>
          <circle cx="18" cy="30" r="3" fill="#D4AF37" opacity="0.3"/>
        </svg>
      </div>

      {/* CSS Animations */}
      <style>{`
        @keyframes floatBrush1 {
          0%, 100% {
            transform: translateY(0px) translateX(0px) rotate(-15deg);
            opacity: 0.4;
          }
          25% {
            transform: translateY(-20px) translateX(10px) rotate(-15deg);
            opacity: 0.5;
          }
          50% {
            transform: translateY(-40px) translateX(20px) rotate(-15deg);
            opacity: 0.3;
          }
          75% {
            transform: translateY(-20px) translateX(10px) rotate(-15deg);
            opacity: 0.45;
          }
        }

        @keyframes floatFlower {
          0%, 100% {
            transform: translateY(0px) rotate(25deg);
            opacity: 0.35;
          }
          33% {
            transform: translateY(-30px) rotate(35deg);
            opacity: 0.45;
          }
          66% {
            transform: translateY(-15px) rotate(15deg);
            opacity: 0.25;
          }
        }

        @keyframes floatDiamond {
          0%, 100% {
            transform: translateY(0px) rotate(45deg);
            opacity: 0.3;
          }
          50% {
            transform: translateY(-35px) rotate(225deg);
            opacity: 0.4;
          }
        }

        @keyframes floatSparkle {
          0%, 100% {
            transform: scale(1) translateY(0px);
            opacity: 0.35;
          }
          50% {
            transform: scale(1.2) translateY(-25px);
            opacity: 0.5;
          }
        }

        @keyframes floatHeart {
          0%, 100% {
            transform: translateY(0px) scale(1);
            opacity: 0.25;
          }
          50% {
            transform: translateY(-40px) scale(1.1);
            opacity: 0.4;
          }
        }

        @keyframes floatBrush2 {
          0%, 100% {
            transform: translateY(0px) rotate(60deg);
            opacity: 0.3;
          }
          33% {
            transform: translateY(-25px) rotate(70deg);
            opacity: 0.4;
          }
          66% {
            transform: translateY(-10px) rotate(50deg);
            opacity: 0.2;
          }
        }

        @keyframes floatLipstick {
          0%, 100% {
            transform: translateX(0px) rotate(-30deg);
            opacity: 0.25;
          }
          50% {
            transform: translateX(-30px) rotate(-20deg);
            opacity: 0.35;
          }
        }

        @keyframes floatPerfume {
          0%, 100% {
            transform: translateY(0px) rotate(15deg);
            opacity: 0.28;
          }
          50% {
            transform: translateY(-45px) rotate(25deg);
            opacity: 0.4;
          }
        }
      `}</style>
    </>
  );
};
